import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@evc/platform";
import { lastValueFrom } from "rxjs";
import { RoutePage } from "../app-routes.enum";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrl: "./login.component.scss",
    standalone: false
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(AuthService) private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const [error, error_description] = [
        params["error"],
        params["error_description"],
      ];

      if (error || error_description) {
        console.debug("[LoginComponent] ngOnInit() -", {
          error,
          error_description,
        });

        await lastValueFrom(this.authService.logout());
        this.router.navigate([RoutePage.IndexPage]);
      }
    });
  }
}
